module.exports = __webpack_public_path__ + "img/16l004-15.0b630b06.png";